import { createContext } from 'react'

const ReloadSession = createContext<(() => Promise<unknown>) | undefined>(undefined)

export default ReloadSession
